export const varsFromServer = window.clientSideInjectionVars || {};
